import { config, openDigitalWelcome } from '../../store/widget-store';
import { useI18n } from '../../hooks/use-i18n';
import { useBubbleDrag } from '../../hooks/use-bubble-drag';
import { DragHint } from '../DragHint';

/**
 * 数字人客服悬浮球(左下角) —— 复刻设计稿 MinimizedButton:
 * 圆形头像 + 双层脉冲呼吸环(CSS keyframes,见 widget.css .dcs-mini-bubble__ring)。
 * 点击进入欢迎屏;长按可拖动调整位置(useBubbleDrag)。
 * showButton=false 时不渲染(沿用既有约定:此时靠 defaultWindow=max 自动展开)。
 */
export function MinimizedBubble() {
  const cfg = config.value;
  const { t } = useI18n();
  const { dragging, style, onClick, pointerHandlers } = useBubbleDrag(openDigitalWelcome);
  if (!cfg || !cfg.showButton) return null;

  const label = t('bubble.open');
  return (
    <button
      type="button"
      class={`dcs-mini-bubble${dragging ? ' dragging' : ''}`}
      aria-label={label}
      title={label}
      style={style}
      onClick={onClick}
      {...pointerHandlers}
    >
      <span class="dcs-mini-bubble__ring" aria-hidden="true" />
      <span class="dcs-mini-bubble__ring dcs-mini-bubble__ring--2" aria-hidden="true" />
      {cfg.avatarUrl ? (
        <img class="dcs-mini-bubble__avatar" src={cfg.avatarUrl} alt="" />
      ) : (
        <span class="dcs-mini-bubble__avatar dcs-mini-bubble__fallback" aria-hidden="true">
          <svg
            viewBox="0 0 24 24"
            width="28"
            height="28"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
          </svg>
        </span>
      )}
      <DragHint dragging={dragging} />
    </button>
  );
}
